/* Hook encargado de reordenar todas las imagenes del vehiculo
Autor: Benjamín León
Fecha: 2024-12-01
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch'

import { makeUrlImagesReorderAll } from './connectionData'

const useImagesReorderAll = () => {
  const [errorImagesReorderAll, setErrorImagesReorderAll] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const imagesReorderAll = async (id: string, registry: boolean) => {
    setLoading(true)

    try {
      const params = new URLSearchParams({
        id: id,
        registry: registry ? '1' : '0',
      })

      const apiUrl = makeUrlImagesReorderAll(params)
      const res = await customFetch<string[]>(apiUrl)
      setErrorImagesReorderAll(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorImagesReorderAll(err)
      } else {
        setErrorImagesReorderAll(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorImagesReorderAll, loading, imagesReorderAll }
}
export default useImagesReorderAll
